<template>
    <div
        id="docs"
        class="cabinet-settings cabinet-settings-documents supplier-tab hide"
        data-title="Документы"
    >
        <div v-if="loading" class="supplier-settings__info">
            Loading..
        </div>

        <template v-else>
            <div class="cabinet-settings-documents__text">
                <p>
                    Загрузите документы, необходимые для заключения договора с
                    вашей компанией. Документы будут доступны для скачивания
                    всем зарегистрированным ритейлерам.
                </p>
                <p>
                    Загружаемый файл может быть в формате .pdf, .jpeg, .png,
                    .doc, .docx или .rtf, а размер не должен превышать 32 Мб.
                </p>
            </div>
            <div class="cabinet-settings-documents__list">
                <DocItem
                    :doc="docs.filter(d => d.type == 'GIISDMDK')"
                    :loading="loadingDocument"
                    title="Уведомление о постановке на учет в ГИИС ДМДК"
                    note=""
                    name="GIISDMDK"
                    @sendDocument="sendFile"
                    @removeDocument="removeDocumentWrapper"
                />
                <DocItem
                    :doc="docs.filter(d => d.type == 'copy_charter')"
                    :loading="loadingDocument"
                    title="Копия Устава в виде последней актуальной редакции"
                    note="Первых 2 листа и последних 2 листа"
                    name="copy_charter"
                    @sendDocument="sendFile"
                    @removeDocument="removeDocumentWrapper"
                />
                <DocItem
                    :doc="docs.filter(d => d.type == 'OGRN')"
                    :loading="loadingDocument"
                    title="Копия свидетельства о гос. регистрации юридического лица (ОГРН)"
                    note=""
                    name="OGRN"
                    @sendDocument="sendFile"
                    @removeDocument="removeDocumentWrapper"
                />
                <DocItem
                    :doc="docs.filter(d => d.type == 'copy_appointment')"
                    :loading="loadingDocument"
                    title="Копия документа (протокол, решение и пр.) о назначении (избрании) физического лица единоличным исполнительным органом юридического лица (директор, ген. директор, президент), от имени которого данное физическое лицо заключает Договор или выдало доверенность на заключение Договора лицу, не являющимся исполнительным органом юридического лица."
                    note=""
                    name="copy_appointment"
                    @sendDocument="sendFile"
                    @removeDocument="removeDocumentWrapper"
                />
                <DocItem
                    :doc="docs.filter(d => d.type == 'INN')"
                    :loading="loadingDocument"
                    title="Копия свидетельства о постановке на учет в налоговом органе (ИНН)"
                    note=""
                    name="INN"
                    @sendDocument="sendFile"
                    @removeDocument="removeDocumentWrapper"
                />
                <DocItem
                    :doc="docs.filter(d => d.type == 'GIPN')"
                    :loading="loadingDocument"
                    title="Копия карты постановки на специальный учет в ГИПН"
                    note=""
                    name="GIPN"
                    @sendDocument="sendFile"
                    @removeDocument="removeDocumentWrapper"
                />
                <DocItem
                    :doc="
                        docs.filter(d => d.type == 'copy_of_power_of_attorney')
                    "
                    :loading="loadingDocument"
                    title="Копия доверенности"
                    note="В случае, если договор заключает (подписывает) не исполнительный орган юридического лица (поверенный) на заключение Договора"
                    name="copy_of_power_of_attorney"
                    @sendDocument="sendFile"
                    @removeDocument="removeDocumentWrapper"
                />
                <DocItem
                    :doc="docs.filter(d => d.type == 'copy_of_passport')"
                    :loading="loadingDocument"
                    title="Копия паспорта (для ИП)"
                    note="Страница с фотографией, регистрацией по месту жительства, наименованием учреждения выдавшего паспорт"
                    name="copy_of_passport"
                    @sendDocument="sendFile"
                    @removeDocument="removeDocumentWrapper"
                />
                <DocItem
                    :doc="
                        docs.filter(d => d.type == 'document_confirming_work')
                    "
                    :loading="loadingDocument"
                    title="Документ, подтверждающий работу без НДС"
                    note=""
                    name="document_confirming_work"
                    @sendDocument="sendFile"
                    @removeDocument="removeDocumentWrapper"
                />
                <DocItem
                    :doc="docs.filter(d => d.type == 'bank_details')"
                    :loading="loadingDocument"
                    title="Банковские реквизиты"
                    note=""
                    name="bank_details"
                    @sendDocument="sendFile"
                    @removeDocument="removeDocumentWrapper"
                />
                <DocItem
                    :doc="docs.filter(d => d.type == 'contacts')"
                    :loading="loadingDocument"
                    title="Юридический, почтовый адреса, телефон, e-mail"
                    note=""
                    name="contacts"
                    @sendDocument="sendFile"
                    @removeDocument="removeDocumentWrapper"
                />
                <div
                    class="cabinet-settings-documents__item cabinet-settings-documents__item--simple"
                >
                    <div
                        class="cabinet-settings-documents__item-title subtitle2 flex"
                    >
                        Бланк(и) договора(ов)
                    </div>
                    <div class="cabinet-settings-documents__item-note">
                        Загружаемый файл может быть в формате .doc, .docx или
                        .rtf, а размер не должен превышать 32 Мб.
                    </div>
                    <div v-if="contracts.length > 0">
                        <div
                            v-for="doc in contracts"
                            :key="doc.id"
                            class="cabinet-settings-documents__item cabinet-settings-documents__item--done"
                        >
                            <div
                                class="cabinet-settings-documents__item-title subtitle2 flex"
                            >
                                {{ doc.document_name }}
                            </div>
                            <div
                                class="cabinet-settings-documents__item-note"
                            ></div>
                            <div
                                v-if="contractLoading !== doc.id"
                                class="cabinet-settings-documents__item-info flex flex-align-center"
                            >
                                {{ doc.original_filename }}
                                <div
                                    class="cabinet-settings-documents__item-icons"
                                >
                                    <a
                                        :href="`${doc.filename}`"
                                        download
                                        target="_blank"
                                        class="cabinet-settings-documents__item-icon"
                                    >
                                        <img
                                            src="/img/icons/download.svg"
                                            alt=""
                                        />
                                    </a>
                                    <a
                                        href="javascript:void(0)"
                                        class="cabinet-settings-documents__item-icon"
                                        @click="removeDocumentWrapper(doc)"
                                    >
                                        <img
                                            src="/img/icons/delete.svg"
                                            alt=""
                                        />
                                    </a>
                                </div>
                            </div>
                            <div
                                v-else
                                class="cabinet-settings-documents__item-loader spinning-loader"
                            ></div>
                        </div>
                    </div>
                    <button
                        type="button"
                        class="cabinet-settings-documents__item-btn subtitle2 mt-16"
                        @click="isDocsModalOpen = true"
                    >
                        Добавить бланк договора
                    </button>
                </div>
            </div>
            <docs-modal
                v-if="isDocsModalOpen"
                :is-open="isDocsModalOpen"
                @closeModal="isDocsModalOpen = false"
                @sendDocument="sendFile"
            />
        </template>
    </div>
</template>

<script>
import DocItem from '@/components/Cabinet/Supplier/Settings/DocsItem'
import DocsModal from '@/components/Cabinet/Supplier/Settings/DocsModal'
import _ from 'lodash'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

export default {
    name: 'Docs',
    components: {
        DocItem,
        DocsModal
    },
    data() {
        return {
            loading: true,
            search: '',
            loadingDocument: '',
            isDocsModalOpen: false,
            contractLoading: 0
        }
    },
    computed: {
        ...mapState('supplierDocs', ['docs', 'error']),
        ...mapState('user', ['user']),
        contracts() {
            return this.docs.filter(d => d.type == 'contract')
        },
        APP_URL() {
            return process.env.VUE_APP_URL_APP
        }
    },
    async mounted() {
        await this.getDocs(this.user.id)
        this.loading = false
    },
    methods: {
        ...mapActions('supplierDocs', [
            'getDocs',
            'uploadDocument',
            'removeDocument'
        ]),
        async removeDocumentWrapper(doc) {
            this.loadingDocument = doc.type
            if (doc.type == 'contract') {
                this.contractLoading = doc.id
            }
            await this.removeDocument(doc.id)
            await this.getDocs(this.user.id)
            this.loadingDocument = ''
            this.contractLoading = 0
        },
        async sendFile(document) {
            this.isDocsModalOpen = false
            this.loadingDocument = document.type
            if (
                document.type !== 'contract' &&
                this.docs.filter(d => d.type == document.type).length > 0
            ) {
                await this.removeDocument(
                    this.docs.filter(d => d.type == document.type)[0].id
                )
            }
            let formData = new FormData()
            formData.append('file', document.event.target.files[0])
            formData.append('user_id', this.user.id)
            formData.append('type', document.type)
            formData.append('document_name', document.title)
            await this.uploadDocument(formData)
            if (this.error) {
                this.$notify({
                    title: this.error,
                    type: 'error'
                })
            }
            await this.getDocs(this.user.id)
            this.loadingDocument = ''
        }
    }
}
</script>
